import React from 'react';
import Checkbox from './Checkbox';

const Fieldset = React.memo((props) => {

    return (
        <fieldset className="fieldset">
            <legend className="legend d-flex align-items-center">{props.label} {props.legendControl}</legend>
            {props.children}
        </fieldset>
    );
})

export default Fieldset;